/* eslint-disable eqeqeq */
import React,{Component}  from 'react';
import{List,InputItem,Button} from 'antd-mobile';
import {connect} from 'dva';
import Loading from './Loading';
class Login extends Component {
    constructor(props){
        super(props);
        this.state={
            AAA202:'',
            AAA203:'',
            message:''
        }
    }
    onChangeAAA202(value)
    {
        this.setState({
            AAA202:value
        });
    }
    onChangeAAA203(value)
    {
        this.setState({
            AAA203:value
        });
    }
    submit(){
        if(!this.state.AAA202)
        {
            this.setState({
                message:"手机号必须输入！"
            });
            return;
        }
        if(!this.state.AAA203)
        {
            this.setState({
                message:"密码必须输入！"
            });
            return;
        }
    
       
        this.props.dispatch({type:"index/login",payload:{
            AAA202:this.state.AAA202.replace(/\s/ig,''),
            AAA203:this.state.AAA203
            
        }}).then(()=>{
            if(this.props.coeds=='NOERROR')
            {
                this.props.dispatch({type:"index/changeRouter",payload:{route:'/home'}});
            }else{
                this.setState({
                    message:this.props.message
                });
            }
            
        });
    }
    render(){
        return(
            <div>
            <h1>
             用户系统登陆
             </h1>
            <List>
            <InputItem type="phone" value={this.state.AAA202} onChange={(value)=>this.onChangeAAA202(value)} placeholder="请输入手机号..." >手机号码</InputItem>
            <InputItem type="password" value={this.state.AAA203} onChange={value=>this.onChangeAAA203(value)} placeholder="请输入密码..." >密码</InputItem>
            <Loading loading={this.props.loading} />
            </List>
            <h2> {this.state.message}</h2>
            <Button type="primary" loading={this.props.loading} disabled={this.props.loading} onClick={()=>this.submit()} >登陆</Button>
     
         
        </div>
        );
    }
}

export default connect(state=>{
    return{
        ...state.index,
        loading: state.loading.global
    }
})(Login) ;

